import { httpClient } from "@coworker/http-client";
import { FileUploadType } from "@fixa/file-upload";

export const NO_WRITE_SIGNED_URLS: SignedUrlResponse[] = [];

export type SignedUrlResponse = {
  fileName: string;
  originalFileName: string;
  signedUrl: string;
};

export async function getWriteSignedUrls(
  fileNames: string[],
  uploadType: FileUploadType
): Promise<SignedUrlResponse[]> {
  if (fileNames.length === 0) {
    return NO_WRITE_SIGNED_URLS;
  }
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.append("fileNames", JSON.stringify(fileNames));
  urlSearchParams.append("uploadType", uploadType);
  return httpClient.tasks.get<SignedUrlResponse[]>(
    `/uploads/write-signed-urls?${urlSearchParams.toString()}`
  );
}

export type SignedFile = {
  file: File;
  signedUrl: string;
};

// Uploads directly to a signed GCS URL — intentionally left as raw fetch
async function uploadSignedFileToBucket(signedFile: SignedFile) {
  const response = await fetch(signedFile.signedUrl, {
    method: "PUT",
    headers: {
      "Content-Type": signedFile.file.type,
    },
    body: signedFile.file,
  });
  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
}

export async function uploadSignedFilesToBucket(signedFiles: SignedFile[]) {
  await Promise.all(
    signedFiles.map((signedFile) => {
      return uploadSignedFileToBucket(signedFile);
    })
  );
}
